(function () {
  'use strict';

  var TARGET = 'https://saname-health-hub.replit.app/recipes';
  var path = window.location.pathname || '';

  function normaliseLabel(value) {
    return (value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function isRecipeLabel(link) {
    if (!link) return false;
    var label = normaliseLabel(
      link.getAttribute('aria-label') ||
      link.getAttribute('title') ||
      link.textContent
    );
    return label === 'recipes' || label === 'recipe vault';
  }

  function isLegacyRecipeUrl(href) {
    if (!href) return false;
    try {
      var url = new URL(href, window.location.origin);
      if (url.href === TARGET) return false;
      if (url.origin !== window.location.origin) return false;
      return url.pathname === '/blogs/recipes' ||
        url.pathname.indexOf('/blogs/recipes/') === 0 ||
        url.pathname === '/pages/recipes' ||
        url.pathname === '/recipes' ||
        url.pathname === '/collections/cooking' ||
        url.pathname === '/collections/recipes' ||
        url.pathname === '/pages/recipe-vault';
    } catch (e) {
      return false;
    }
  }

  function shouldForceRecipeTarget(link) {
    return !!link && (isRecipeLabel(link) || isLegacyRecipeUrl(link.getAttribute('href')));
  }

  // Hard client-side fallback for any legacy SANAME recipe route.
  if (
    path === '/blogs/recipes' || path.indexOf('/blogs/recipes/') === 0 ||
    path === '/pages/recipes' || path === '/recipes' ||
    path === '/collections/cooking' || path === '/collections/recipes' ||
    path === '/pages/recipe-vault'
  ) {
    window.location.replace(TARGET);
    return;
  }

  function updateLink(link) {
    if (shouldForceRecipeTarget(link)) {
      link.setAttribute('href', TARGET);
    }
  }

  function updateAll(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('a').forEach(updateLink);
  }

  updateAll(document);

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a');
    if (!link) return;
    if (shouldForceRecipeTarget(link)) {
      event.preventDefault();
      window.location.assign(TARGET);
    }
  }, true);

  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches('a')) updateLink(node);
          updateAll(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
